module.exports = __webpack_public_path__ + "media/images/entidades_organizadoras/fpceuc-f2ebf66a159f02cf3ade876ab52e7849.svg";